import React, { useEffect, useState } from 'react';
import { isNaN, isNil } from 'lodash';
import countDownHelper from '../../../help/countdown';

import './ProductOfferDescription.scss';

const ProductOfferDescription = ({ tag, idx, showArrow }) => {
  const [countDown, setCountDown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const generateDescription = () => {
    const targetDate = new Date(tag.countdown);
    const r = new RegExp(/(\[\[\s*countdown\s*\]\])+/gi);
    if (
      isNil(tag.countdown) ||
      isNaN(targetDate.getTime()) ||
      Date.now() >= targetDate.getTime()
    ) {
      return tag.descriptionText.replace(r, '').trim();
    }
    const countDownText = countDownHelper.generateCountdownText(countDown);
    return tag.descriptionText.replace(r, countDownText);
  };

  useEffect(() => {
    const targetDate = new Date(tag.countdown);
    if (
      !isNil(tag.countdown) &&
      !isNaN(targetDate.getTime()) &&
      Date.now() < targetDate.getTime()
    ) {
      const interval = setInterval(() => {
        const c = countDownHelper.generateCountdown(targetDate);
        setCountDown(c);
      }, 250);

      return () => clearInterval(interval);
    }
  }, []);

  return !tag.descriptionText ? (
    <></>
  ) : (
    <div className='prd-price-discount-description'>
      {showArrow && idx === 0 && (
        <svg
          className='prd-price-discount-description-arrow'
          height='20'
          width='20'>
          <path d='M0 0 L0 20 L20 20 Z' />
        </svg>
      )}
      <p
        dangerouslySetInnerHTML={{
          __html: generateDescription(),
        }}
      />
    </div>
  );
};

export default ProductOfferDescription;
